import React from 'react';

import {
  ColorProps, Flex, FlexProps, Text, ThemingProps,
} from '@chakra-ui/react';
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';

import { Icon } from 'components';

type Variants = ThemingProps<'Text'>['variant']

interface InfoRowProps extends FlexProps {
  label: string
  labelVariant?:Variants
  labelColor?: ColorProps['color']
  value: string
  valueColor?: ColorProps['color']
  valueVariant?: Variants
  direction?: 'row' | 'column'
  suffix?: ''
  parser?: (_:any) => string
}

export function InfoRow({
  label,
  value,
  labelVariant = 'xSmallSemiBold',
  labelColor = 'gray.700',
  valueColor = 'gray.700',
  valueVariant = 'xSmallRegular',
  direction = 'row',
  suffix = '',
  parser = (val: any) => String(val),
  ...rest
}: InfoRowProps) {
  return (
    <Flex
      flexDir={direction}
      {...rest}>
      <Text
        variant={labelVariant}
        color={labelColor}
        mr={2}>
        {label}
      </Text>
      <Text
        color={valueColor}
        variant={valueVariant}>
        {parser(value)?.concat(suffix)}
      </Text>
    </Flex>
  );
}

interface IconRowProps {
  label: IconName
  labelVariant?:IconPrefix
  labelColor?: string
  value: string
  valueColor?: string
  valueVariant?: Variants
  direction?: 'row' | 'column'
}

export function IconRow({
  label,
  value,
  labelVariant = 'fas',
  labelColor = 'gray.700',
  valueColor = 'gray.600',
  valueVariant = 'xSmallRegular',
  direction = 'column',
}:IconRowProps) {
  return (
    <Flex flexDir={direction}>
      <Icon
        family={labelVariant}
        color={labelColor}
        name={label}
        mr={1}
      />
      <Text
        variant={valueVariant}
        color={valueColor}>
        {value}
      </Text>
    </Flex>
  );
}
